export default "__VITE_ASSET__N$wpGc5E__"